// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import { ActionCell } from './ActionCell'
import { NumberCell } from './NumberCell'

const topupPacksColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Name"
        className="min-w-100px"
      />
    ),
    id: "name",
    Cell: ({ ...props }) => (
      <TitleCell userObj={props.data[props.row.index]?.name} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Slug"
        className="min-w-80px"
      />
    ),
    id: "slug",
    Cell: ({ ...props }) => (
      <TitleCell userObj={props.data[props.row.index]?.slug} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Price (EGP)"
        className="min-w-80px"
      />
    ),
    id: "priceEgp",
    Cell: ({ ...props }) => (
      <NumberCell userObj={props.data[props.row.index]?.priceEgp} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Discounted Price"
        className="min-w-80px"
      />
    ),
    id: "discountedPriceEgp",
    Cell: ({ ...props }) => (
      <NumberCell userObj={props.data[props.row.index]?.discountedPriceEgp} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Credits"
        className="min-w-80px"
      />
    ),
    id: "credits",
    Cell: ({ ...props }) => (
      <NumberCell userObj={props.data[props.row.index]?.credits} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Active"
        className="min-w-50px"
      />
    ),
    id: "isActive",
    Cell: ({ ...props }) => (
      <TitleCell userObj={props.data[props.row.index]?.isActive ? "Yes" : "No"} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Action"
        className="min-w-75px"
      />
    ),
    id: "action",
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
];

export { topupPacksColumns }
